import { useFormContext } from 'react-hook-form';

import Typography from 'components/global/Typography';

import * as S from './styled/ColorInput.styled';

/**
 * @description color input to allow user select color
 * @param {Object} props - props of the component.
 * @param {Boolean} [props.disabled=false] - disabled state of the input field.
 * @param {String} [props.name] - name of the input field.
 * @param {Boolean} [props.viewMode=false] - viewMode state of the input field.
 * @param {String} [props.className] - className of the input field.
 * @param {String} [props.style] - style of the input field.
 * @param {String} [props.value] - value of the global component.
 * @param {Function} [props.setValue] - setValue function for global component.
 * @returns {JSX} StringInput component.
 * @example
 * <ColorInput
 * value={value}
 * setValue={setValue}
 * />
 */

const ColorInput = (props) => {
	const { name, viewMode, style, className } = props;

	return (
		<>
			{viewMode ? (
				<ViewComponent {...props} />
			) : (
				<S.InputContainer style={style} className={className}>
					{name ? <FormComponent {...props} /> : <GlobalComponent {...props} />}
				</S.InputContainer>
			)}
		</>
	);
};

const ViewComponent = (props) => {
	const { name = '', value } = props;

	const formMethods = useFormContext();
	const viewValue = name ? formMethods?.getValues(name) : value;

	return <Typography>{viewValue}</Typography>;
};

const FormComponent = (props) => {
	const { disabled, name } = props;

	const formMethods = useFormContext();
	const register = formMethods?.register;

	return <input disabled={disabled} type="color" {...register(name)} />;
};

const GlobalComponent = (props) => {
	const { disabled, value, setValue } = props;

	return <input disabled={disabled} type="color" value={value} onChange={setValue} />;
};

export default ColorInput;
